import { Component, OnInit } from '@angular/core';
import {SanctionLog} from "app/shared/models/SanctionLog.model";
import { ReportsService } from './../reports.service';

@Component({
  selector: 'app-sanctionlogs',
  templateUrl: './sanctionlogs.component.html',
  styleUrls: ['./sanctionlogs.component.css'],
  providers:[ReportsService]
})
/**
 * Component to display the Sanction Logs.
 */
export class SanctionlogsComponent implements OnInit {

  sanctionLogs: SanctionLog[];

  constructor(
        private reportService: ReportsService 
  ) { }

  ngOnInit() {
  this.getAllSanctionLogs();
  }
  
  getAllSanctionLogs(){
        this.reportService.getSanctionMatchingLogsList()
        .subscribe(sanctions => { this.sanctionLogs = sanctions; });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/reports/sanctionlogs/sanctionlogs.component.ts